const STAGGER_MS = 200
const BATCH_MS = 50

export function initFadeInUp(): void {
  const elements = document.querySelectorAll<HTMLElement>('.fade-in-up')
  if (!elements.length) return

  const pending = new Map<Element, HTMLElement[]>()
  let timer: ReturnType<typeof setTimeout> | null = null

  const flush = () => {
    timer = null
    for (const [, batch] of pending) {
      batch.sort((a, b) => {
        const ra = a.getBoundingClientRect()
        const rb = b.getBoundingClientRect()
        if (Math.abs(ra.top - rb.top) > 40) return ra.top - rb.top
        return ra.left - rb.left
      })
      batch.forEach((el, i) => {
        el.style.animationDelay = `${i * STAGGER_MS}ms`
        el.classList.add('is-visible')
      })
    }
    pending.clear()
  }

  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue
        const el = entry.target as HTMLElement
        observer.unobserve(el)

        const container = el.closest<Element>('[data-stagger-container]')
        const key = container ?? el.parentElement ?? document.body
        if (!pending.has(key)) pending.set(key, [])
        pending.get(key)!.push(el)
      }

      if (timer !== null) clearTimeout(timer)
      timer = setTimeout(flush, BATCH_MS)
    },
    { threshold: 0.1, rootMargin: '0px 0px -32px 0px' },
  )

  elements.forEach((el) => observer.observe(el))
}
